/**
 * Referral Module
 *
 * Exports for referral codes, tracking, and rewards.
 */

// Types
export type {
  ReferralCode,
  Referral,
  ReferralReward,
  ReferralStats,
  ReferralStatus,
} from './types';

// Constants
export {
  REFERRAL_DISCOUNT_PERCENT,
  REFERRAL_CODE_LENGTH,
  REFERRAL_CODE_PREFIX_STARTUP,
  REFERRAL_CODE_PREFIX_INVESTOR,
  REFERRAL_CONVERSION_WINDOW_DAYS,
  REFERRAL_REWARD_EXPIRY_DAYS,
} from './types';

// Helpers
export {
  generateReferralCode,
  isWithinConversionWindow,
  isRewardValid,
  formatReferralDiscount,
} from './types';

// Store
export {
  useReferralStore,
  useMyReferralCode,
  useReferralStats,
  useHasActiveDiscount,
} from './referral-store';

// Link helpers
export {
  useReferralFromUrl,
  generateReferralLink,
  generateDeepLink,
  extractReferralCode,
  isValidReferralCodeFormat,
  REFERRAL_PARAM,
  APP_BASE_URL,
} from './useReferralLink';
